import { render, staticRenderFns } from "./PlanMenu.vue?vue&type=template&id=d3018640&scoped=true"
import script from "./PlanMenu.vue?vue&type=script&lang=js"
export * from "./PlanMenu.vue?vue&type=script&lang=js"
import style0 from "./PlanMenu.vue?vue&type=style&index=0&id=d3018640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3018640",
  null
  
)

export default component.exports